const statuses = {
    ACTIVE_EVERGREEN: 'ACTIVE_EVERGREEN',
    ACTIVE_EVERGREEN_CANCELED: 'ACTIVE_EVERGREEN_CANCELED',
    ACTIVE_TERMED: 'ACTIVE_TERMED',
    ACTIVE_TERMED_CANCELED: 'ACTIVE_TERMED_CANCELED',
    ACTIVE_TERMED_DISCONTINUED: 'ACTIVE_TERMED_DISCONTINUED',
    INACTIVE_EVERGREEN: 'INACTIVE_EVERGREEN',
    INACTIVE_EVERGREEN_CANCELED: 'INACTIVE_EVERGREEN_CANCELED',
    INACTIVE_TERMED: 'INACTIVE_TERMED',
    INACTIVE_TERMED_CANCELED: 'INACTIVE_TERMED_CANCELED',
    INACTIVE_TERMED_DISCONTINUED: 'INACTIVE_TERMED_DISCONTINUED',
    EXPIRED_EVERGREEN: 'EXPIRED_EVERGREEN',
    EXPIRED_TERMED: 'EXPIRED_TERMED',
    EMPTY: 'EMPTY',
    PAUSED: 'PAUSED',
    SHARED: 'SHARED',
};

export const subscriptionStatuses = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    EXPIRED: 'EXPIRED',
};

export const subscriptionTypes = {
    EVERGREEN: 'EVERGREEN',
    TERMED: 'TERMED',
};

export const renewalStatuses = {
    CANCELED: 'CANCELED',
    DISCONTINUED: 'DISCONTINUED',
};

export const invoiceStatuses = {
    PAID: 'PAID',
    TO_BE_CHARGED: 'TO_BE_CHARGED',
    FAILED: 'FAILED',
    UNPAID: 'UNPAID',
};

export const sharingStatuses = {
    ACCEPTED: 'ACCEPTED',
};

export const asArray = Object.keys(statuses);

export default statuses;
